import { useState } from "react";
import { PartitionOutlined } from "@ant-design/icons";
import { IconButton } from "@/components/UI/TableToolbar/IconButton";
import ProvenanceDrawer from "./ProvenanceDrawer";

interface ProvenanceButtonProps {
  /** Dataset key for this screen; the backend resolves it to core tables. */
  datasetName: string;
  title?: string;
  testId?: string;
}

/**
 * Toolbar affordance for "where did this screen's data come from?".
 *
 * Sits beside the guide button because it answers the same kind of question
 * about the page as a whole, rather than about any one row.
 */
export default function ProvenanceButton({
  datasetName,
  title,
  testId = "provenance-button",
}: ProvenanceButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton
        data-testid={testId}
        icon={<PartitionOutlined />}
        title="Where this page's data came from"
        isOpen={isOpen}
        onClick={() => setIsOpen(true)}
      />
      {/* Mounted only once opened so the drawer's fetch never runs for the
          many users who never ask the question. */}
      {isOpen && (
        <ProvenanceDrawer
          open={isOpen}
          onClose={() => setIsOpen(false)}
          datasetName={datasetName}
          title={title}
        />
      )}
    </>
  );
}
